'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import UIUpgradeBanner from 'ui-addon-upgrades/ums/UIUpgradeBanner';
import { jsx as _jsx } from "react/jsx-runtime";
class CreditLimitAlert extends Component {
  renderLimitReachedAlert() {
    const {
      creditsUsed,
      portalLimit,
      hasUnpaidExperience
    } = this.props;
    const upgradeType = !hasUnpaidExperience ? 'pro' : 'starter';
    return /*#__PURE__*/_jsx(UIUpgradeBanner, {
      upgradeKey: `email-ui-lib-credit-marketing-${upgradeType}-usage-limit`,
      value: creditsUsed,
      limit: portalLimit
    });
  }
  render() {
    const {
      hasReachedThreshold
    } = this.props;
    if (hasReachedThreshold) {
      return this.renderLimitReachedAlert();
    }
    return null;
  }
}
CreditLimitAlert.propTypes = {
  hasUnpaidExperience: PropTypes.bool,
  creditsUsed: PropTypes.number,
  portalLimit: PropTypes.number,
  hasReachedThreshold: PropTypes.bool
};
export default CreditLimitAlert;